export const ROUTE_PERFECT_EXAMPLES: string[] = [
  'Can you plan a 10-day cultural trip to Italy with local cuisine and architecture?',
  'Plan a romantic weekend in France with must-see attractions.',
  'I need help planning a one-week trip to Spain for my family.',
  'Plan a two-week trip to Scandinavia for hiking in Norway, and exploring Copenhagen and Stockholm.',
];

export const LITHUANIAN_EXAMPLES: string[] = [
  'plan a 10-day cultural trip with local cuisine and architecture.',
  'plan a romantic weekend with must-see attractions.',
  'I need help planning a one-week trip for my family.',
  'Plan a two-week trip for hiking and exploring Vilnius.',
];
